<template>
  <right-panel :datas="connects" ref="addInstance" @onClose="onClose">
    <div slot="header">
      <translate v-if="this.$route.query.type === 'ecs'">Add The Host In Bulk</translate>
      <translate v-if="this.$route.query.type === 'rds'">Add The Database In Bulk</translate>
    </div>
    <div slot="content" class="wrapper-padding">
      <el-row class="step">
        <el-col :span="6" class="step-title">
          <translate>First Step</translate>
        </el-col>
        <el-col :span="18" class="step-text">
          <translate v-if="this.$route.query.type === 'ecs'">Download The Host List, Fill In The Host Information</translate>
          <translate v-if="this.$route.query.type === 'rds'">Download The Database List, Fill In The Database Information</translate>
          <a :href="downUrl" @click="onDownUrl" class="down-load">
            <translate>Download</translate>
          </a>
        </el-col>
      </el-row>
      <el-row class="step">
        <el-col :span="6" class="step-title secont-title">
          <translate>Second Step</translate>
        </el-col>
        <el-col :span="18" class="step-text">
          <translate v-if="this.$route.query.type === 'ecs'">Upload The Host List</translate>
          <translate v-if="this.$route.query.type === 'rds'">Upload The Database List</translate>
          <span @click="$refs['upload-file'].onClick()">
            <file-base64
              :fileInfo = fileInfo
              :progress="onProgress"
              ref="upload-file"
              :done="uploadFiles">
            </file-base64>
          </span>
          <ul class="upload-list" v-if="fileInfo">
            <li class="list-item">
              <el-row style="height: 20px">
                <el-col :span="13" class="word-wrap">{{fileInfo.name}}</el-col>
                <el-col :span="9">{{`${fileInfo.size / 1000}kB`}}</el-col>
                <el-col :span="2">
                  <a href="javascript:;" class="close-file" @click="onCloseFile">
                    <i class="fa fa-lg fa-times-circle-o"></i>
                  </a>
                </el-col>
              </el-row>
              <el-progress :percentage="progress" :show-text="false" :stroke-width="3"></el-progress>
              <div class="err-code">
                {{errMsg}}
              </div>
            </li>
          </ul>
        </el-col>
      </el-row>
    </div>
    <div slot="footer" class="detail-btn">
      <el-button type="primary" @click="onUpload()" :disabled="!fileInfo && progress !== 100">
        <translate>Upload</translate>
      </el-button>
      <el-button @click="$refs.addInstance.onClose()">
        <translate>Cancel</translate>
      </el-button>
    </div>
  </right-panel>
</template>

<script>
  import STORE_CONST from '../../../store/consts'
  import RightPanel from '../../common/right-panel'
  import fileBase64 from './vue-upload-file'
  import { baseUrl } from '../../../config'
  export default{
    name: 'ClusterBatchInstance',
    props: {
      items: {
        required: true
      }
    },
    data () {
      return {
        connects: null,
        fileInfo: null,
        progress: 0,
        downUrl: '',
        errMsg: ''
      }
    },
    methods: {
      // 获取待上传文件
      uploadFiles (file) {
        this.fileInfo = Object.assign({}, file)
      },
      // 确定上传文件
      onUpload () {
        let params = {
          network_id: Number(this.$route.params.id),
          resource_type: this.$route.query.type,
          content: [{
            data: this.fileInfo.base64.split('base64,')[1],
            file_name: this.fileInfo.name,
            extension: this.fileInfo.name.split('.')[1]
          }]
        }
        this.$store.dispatch(STORE_CONST.CLUSTER.XLSX_BATCH_IMPORT, params).then((res) => {
          this.$emit('callback')
          this.onClose()
          this.$notify({
            message: this.$gettext('Upload successfully!'),
            type: 'success'
          })
        }).catch(err => {
          console.log('err ==>', err)
          let totalLength = err.error_message.length
          if (err.code === 'FileEmptyError') {
            this.errMsg = this.$gettext('The resource list is empty. Please check again!')
          } else if (err.code === 'ResourceExceeded') {
            this.errMsg = this.$gettext('Exceeding the maximum number of resources')
          } else if (err.code === 'FileDataError') {
            let firstIndex = err.error_message.lastIndexOf(':')
            let secondIndex = err.error_message.lastIndexOf('-')
            let row = err.error_message.substring(firstIndex + 1, secondIndex)
            let col = err.error_message.substring(secondIndex + 1, totalLength)
            this.errMsg = '第' + row + '行,第' + col + '列出现错误!'
          } else if (err.code === 'FileTypeError') {
            this.errMsg = this.$gettext('Please upload the correct form!')
          } else if (err.code === 'ResourceExist') {
            let firstIndex = err.error_message.indexOf('[')
            let lastIndex = err.error_message.lastIndexOf(']')
            let errIpStr = err.error_message.substring(firstIndex + 1, lastIndex)
            this.errMsg = this.$gettext('Intranet IP:') + errIpStr + this.$gettext('exist!')
          } else if (err.code === 'FileResourceExist') {
            let firstIndex = err.error_message.indexOf('[')
            let lastIndex = err.error_message.lastIndexOf(']')
            let errIpStr = err.error_message.substring(firstIndex + 1, lastIndex)
            this.errMsg = this.$gettext('Intranet IP:') + errIpStr + this.$gettext('exist!')
          }
        })
      },
      // 进度
      onProgress (progress) {
        this.progress = progress
      },
      // 下载文件
      onDownUrl () {
        if (this.$language.current === 'zh_CN') {
          if (this.$route.query.type === 'ecs') {
            this.downUrl = `${baseUrl.apiUrl}/download/local_file/ecs.xlsx`
          } else {
            this.downUrl = `${baseUrl.apiUrl}/download/local_file/database.xlsx`
          }
        } else {
          if (this.$route.query.type === 'ecs') {
            this.downUrl = `${baseUrl.apiUrl}/download/local_file/ecs_english.xlsx`
          } else {
            this.downUrl = `${baseUrl.apiUrl}/download/local_file/database_english.xlsx`
          }
        }
      },
      onCloseFile () {
        this.fileInfo = null
        this.progress = 0
        this.errMsg = ''
      },
      onClose () {
        this.connects = null
        this.$emit('onClosePanel')
      }
    },
    watch: {
      'items': {
        handler: function (newVal) {
          if (this.connects) {
            this.connects = null
            setTimeout(() => {
              this.connects = this.items
            }, 300)
          } else {
            this.connects = this.items
          }
        },
        deep: true
      }
    },
    components: {
      RightPanel,
      fileBase64
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../../assets/css/variable";

  .down-load {
    color: $mainColor;
    cursor: pointer;
  }

  .upload-list {
    margin-top: 20px;
    .list-item {
      .word-wrap {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      .close-file {
        color: red;
      }
      .err-code {
        line-height: 25px;
        color: red;
      }
    }
  }

  .step {
    margin-top: 20px;
    span {
      line-height: 20px;
    }
    .step-title {
      text-align: right;
      padding-right: 10px;
      &.secont-title {
        line-height: 32px;
      }
    }
    .step-text {
      .upload-demo {
        display: inline-block;
        line-height: 32px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// cluster-batch-instances.vue?22ab915a